exports.FormatDate = (date) => {
	if (date == undefined || date == "") {
		return "";
	}
	var Dt = new Date(date);

	var xYear = Dt.getFullYear();
	var xMonth = Dt.getMonth() + 1;
	if (xMonth < 10) {
		xMonth = "0" + xMonth;
	}
	var xDay = Dt.getDate();
	if (xDay < 10) {
		xDay = "0" + xDay;
	}
	return xYear + "-" + xMonth + "-" + xDay;
};

exports.FormatDateTime = (date) => {
	if (date == undefined || date == "") {
		return "";
	}
	var Dt = new Date(date);

	var xYear = Dt.getFullYear();
	var xMonth = Dt.getMonth() + 1;
	if (xMonth < 10) {
		xMonth = "0" + xMonth;
	}
	var xDay = Dt.getDate();
	if (xDay < 10) {
		xDay = "0" + xDay;
	}
	return xYear + "-" + xMonth + "-" + xDay + " " + Dt.getHours() + ":" + Dt.getMinutes() + ":" + Dt.getSeconds();
};
exports.FormatDateTimeLateOneSecond = (date) => {
	if (date == undefined || date == "") {
		return "";
	}
	var newDate = new Date(date);
	var Dt = new Date(newDate.getTime() + 1 * 1000);
	var xYear = Dt.getFullYear();
	var xMonth = Dt.getMonth() + 1;
	if (xMonth < 10) {
		xMonth = "0" + xMonth;
	}
	var xDay = Dt.getDate();
	if (xDay < 10) {
		xDay = "0" + xDay;
	}
	return xYear + "-" + xMonth + "-" + xDay + " " + Dt.getHours() + ":" + Dt.getMinutes() + ":" + Dt.getSeconds();
};
exports.FormatDateTimeLateThreeSecond = (date) => {
	if (date == undefined || date == "") {
		return "";
	}
	var newDate = new Date(date);
	var Dt = new Date(newDate.getTime() + 3 * 1000);

	var xYear = Dt.getFullYear();
	var xMonth = Dt.getMonth() + 1;
	if (xMonth < 10) {
		xMonth = "0" + xMonth;
	}
	var xDay = Dt.getDate();
	if (xDay < 10) {
		xDay = "0" + xDay;
	}
	return xYear + "-" + xMonth + "-" + xDay + " " + Dt.getHours() + ":" + Dt.getMinutes() + ":" + Dt.getSeconds();
};
exports.FromatterBr = (value) => {
	if (value != '' & value != undefined & value != null) {
		return value.replace(new RegExp("<br/>", "gm"), "\r\n");
	}
}

//数量的小数位数
exports.FormatFloatAmount = (value) => {
	//value != '' 调整为 value.toString() != '' 原因  0 等于'' 0 转换 0.00 失败 
	if (value.toString() != '' & value != undefined & value != null) {
		return parseFloat(value).toFixed(0);
	}
}
//小数位数
exports.Formatfloat = (value) => {
	//value != '' 调整为 value.toString() != '' 原因  0 等于'' 0 转换 0.00 失败 
	if (value.toString() != '' & value != undefined & value != null) {
		return parseFloat(parseFloat(value).toFixed(2));
	}
}

//小数位数
exports.FormatfloatP2 = (value) => {
	//value != '' 调整为 value.toString() != '' 原因  0 等于'' 0 转换 0.00 失败 
	if (value.toString() != '' & value != undefined & value != null) {
		return parseFloat(parseFloat(value).toFixed(2));
	}
}

//小数位数
exports.FormatFloatInteger = (value) => {
	//value != '' 调整为 value.toString() != '' 原因  0 等于'' 0 转换 0.00 失败 
	if (value.toString() != '' & value != undefined & value != null) {
		return parseFloat(value).toFixed(0);
	}
}
//小数位数 数字
exports.FormatFloatInteger2 = (value) => {
	//value != '' 调整为 value.toString() != '' 原因  0 等于'' 0 转换 0.00 失败 
	if (value.toString() != '' & value != undefined & value != null) {
		return parseFloat(parseFloat(value).toFixed(0));
	}
}
//设备-电压-IOT设备
exports.FormatBATT = (value) => {
	if (value != '' & value != undefined & value != null) {
		var result = parseFloat(parseFloat(parseFloat(value) / 36).toFixed(0));
		return (result > 100 ? "100" : result) + "%";
	}
}
//设备-电压-TCP设备
exports.FormatBATTTCP = (value) => {
	if (value != '' & value != undefined & value != null) {
		var result = parseFloat(parseFloat(parseFloat(value) / 42).toFixed(0));
		return (result > 100 ? "100" : result) + "%";
	}
}
//设备-电压-道路精灵
exports.FormatBATTRG = (value) => {
	if (value == '' || value == undefined || value == null) {
		return "100%";
	}
	if (value <= 3300) {
		return "0%"
	}
	var result = ((parseFloat(value) - 3300) / 9).toFixed(0);
	return (result > 100 ? "100" : result) + "%";
}
//设备-信号质量
exports.FormatCSQ = (value) => {
	if (value != '' & value != undefined & value != null) {
		let csq = parseFloat(parseFloat(value) / 31 * 100);
		if (csq > 100) {
			csq = 100;
		}
		return csq.toFixed(0) + "%";
	}
}

//派工单状态
exports.FormatDispatchStatus = (value) => {
	switch (value) {
		case "0":
		case 0:
			return "待审核";
		case "1":
		case 1:
			return "已审核";
		case "2":
		case 2:
			return "施工中";
		case "3":
		case 3:
			return "已完工";
		case "4":
		case 4:
			return "验收中";
		case "5":
		case 5:
			return "已验收";
		default:
			return "";
	}
}

//派工单状态-对应的颜色
exports.FormatDispatchStatusColor = (value) => {
	switch (value) {
		case "0":
		case 0:
			return "cell-New";
		case "1":
		case 1:
			return "cell-Approved";
		case "2":
		case 2:
			return "cell-Installing";
		case "3":
		case 3:
			return "cell-Finished";
		case "4":
		case 4:
			return "cell-Checking";
		case "5":
		case 5:
			return "cell-Checkhed";
		default:
			return "cell-grey";
	}
}

//项目管理
exports.FormatProjectStatus = (value) => {
	switch (value) {
		case "0":
		case 0:
			return "待审核";
		case "1":
		case 1:
			return "立项";
		case "2":
		case 2:
			return "招投标";
		case "3":
		case 3:
			return "合同";
		case "4":
		case 4:
			return "验收";
		case "5":
		case 5:
			return "审计";
		default:
			return "";
	}
}

//项目管理-对应的颜色
exports.FormatProjectStatusColor = (value) => {
	switch (value) {
		case "0":
		case 0:
			return "cell-New";
		case "1":
		case 1:
			return "cell-Approved";
		case "2":
		case 2:
			return "cell-Installing";
		case "3":
		case 3:
			return "cell-Finished";
		case "4":
		case 4:
			return "cell-Checking";
		case "5":
		case 5:
			return "cell-Checkhed";
		default:
			return "cell-grey";
	}
}

//安装工单状态
exports.FormatInstallStatus = (value) => {
	switch (value) {
		case "0":
		case 0:
			return "待审核";
		case "1":
		case 1:
			return "未施工";
		case "2":
		case 2:
			return "施工中";
		case "3":
		case 3:
			return "已完工";
		case "4":
		case 4:
			return "验收中";
		case "5":
		case 5:
			return "已验收";
		default:
			return "";
	}
}
//安装工单状态-对应的颜色
exports.FormatInstallStatusColor = (value) => {
	switch (value) {
		case "0":
		case 0:
			return "cell-Installing";
		case "1":
		case 1:
			return "cell-green";
		case "2":
		case 2:
			return "cell-Checking";
		case "3":
		case 3:
			return "cell-Checkhed";
		default:
			return "cell-red";
	}
}

//反馈工单状态
exports.FormatFeedbackStatus = (value) => {
	switch (value) {
		case "1":
		case 1:
			return "未反馈";
		case "2":
		case 2:
			return "反馈中";
		case "3":
		case 3:
			return "已反馈";
		default:
			return "";
	}
}
//验收单状态
exports.FormatCheckStatus = (value) => {
	switch (value) {
		case "0":
		case 0:
			return "验收中";
		case 1:
		case "1":
			return "已验收";
		default:
			return "待验收";
	}
}
//验收单状态-对应的颜色
exports.FormatCheckStatusColor = (value) => {
	switch (value) {
		case "0":
		case 0:
			return "cell-Checking";
		case "1":
		case 1:
			return "cell-Checkhed";
		default:
			return "cell-grey";
	}
}
//验收单状态
exports.FormatAssessStatus = (value) => {
	switch (value) {

		case 1:
		case "1":
			return "考核中";
		case "3":
		case 3:
			return "已考核";
		case "0":
		case 0:
		default:
			return "待考核";
	}
}
//验收单状态-对应的颜色
exports.FormatAssessStatusColor = (value) => {
	switch (value) {
		case "1":
		case 1:
			return "cell-Checking";
		case "3":
		case 3:
			return "cell-Checkhed";
		case "0":
		case 0:
		default:
			return "cell-grey";
	}
}


//设备资源日志类型
exports.FormatMessageType = (value) => {
	switch (value) {
		case 1:
		case "1":
			return "告警";
		case 2:
		case "2":
			return "定时上报";
		case 3:
		case "3":
			return "其他";
		case 4:
		case "4":
			return "用户一键上报";
		case 5:
		case "5":
			return "低电量报警";
		case 6:
		case "6":
			return "电量恢复正常";
		case 7:
		case "7":
			return "温度异常";
		case 8:
		case "8":
			return "温度恢复正常";
		case 9:
		case "9":
			return "倾倒报警";
		case 10:
		case "10":
			return "离线";
		case 11:
		case "11":
			return "上线";
		case 12:
		case "12":
			return "倾倒恢复正常";
		case 13:
		case "13":
			return "位移异常";
		case 14:
		case "14":
			return "位移恢复正常";
		case 15:
		case "15":
			return "终端应答";
		case 16:
		case "16":
			return "终端上电";
		case 17:
		case "17":
			return "GPS定位成功";
		case 18:
		case "18":
			return "震动";
		default:
			return "";
	}
}

//设备资源日志类型-对应的颜色
exports.FormatMessageTypeColor = (value) => {
	switch (value) {
		case "1":
		case "4":
		case "5":
		case "7":
		case "9":
		case "10":
		case "13":
			return "cell-red";
		case "2":
			return "cell-blue";
		case "3":
			return "cell-grey";
		case "11":
			return "cell-green";
		case "6":
		case "8":
		case "12":
		case "14":
			return "cell-yellow";
		default:
			return "cell-grey";
	}
}

//设备告警类型 1、碰撞；2、低电量；3、位置偏移；4、倾斜
exports.FormatAlarmType = (value) => {
	switch (value) {
		case 1:
		case "1":
			return "碰撞";
		case 2:
		case "2":
			return "低电量";
		case 3:
		case "3":
			return "位置偏移";
		case 4:
		case "4":
			return "倾斜";
		case 6:
		case "6":
			return "水位";
		case 7:
		case "7":
			return "超高预警";
		case 8:
		case "8":
			return "一键报警";
		default:
			return "";
	}
}
//设备告警类型 1、碰撞；2、低电量；3、位置偏移；4、倾斜
exports.FormatOperators = (value) => {
	switch (value) {
		case 1:
		case "1":
			return "移动";
		case 2:
		case "2":
			return "联通";
		case 3:
		case "3":
			return "电信";
		case 4:
		case "4":
			return "TCP";
	}
}
//调拨状态
exports.FormatAllotStatus = (value) => {
	switch (value) {
		case 0:
		case "0":
			return "待出库";
		case 1:
		case "1":
			return "待入库";
		case 2:
		case "2":
			return "完成";
	}
}
//调拨状态
exports.FormatRodeName = (value) => {
	switch (value) {
		case "":
			return "仓库";
		default:
			return value;
	}
}


//迁移工单状态
exports.FormatMoveStatus = (value) => {
	switch (value) {
		case "2":
		case 2:
			return "施工中";
		case "3":
		case 3:
			return "已完工";
		default:
			return "";
	}
}

//迁移工单状态-对应的颜色
exports.FormatMoveStatusColor = (value) => {
	switch (value) {
		case "2":
		case 2:
			return "cell-Installing";
		case "3":
		case 3:
			return "cell-Finished";
		default:
			return "cell-grey";
	}
}

//迁移工单状态
exports.FormatScrapStatus = (value) => {
	switch (value) {
		case "2":
		case 2:
			return "待审批";
		case "3":
		case 3:
			return "已审批";
		default:
			return "";
	}
}

//迁移工单状态-对应的颜色
exports.FormatScrapStatusColor = (value) => {
	switch (value) {
		case "2":
		case 2:
			return "cell-Installing";
		case "3":
		case 3:
			return "cell-Finished";
		default:
			return "cell-grey";
	}
}



//资产分布-地图标记形状
exports.FormatProductPointShape = (value) => {
	switch (value) {
		case 1:
		case "1":
			return "水滴";
		case 2:
		case "2":
			return "五角星";
		case 3:
		case "3":
			return "圆形";
		case 4:
		case "4":
			return "菱形";
		case 5:
		case "5":
			return "方形";
	}
}

//资产分布-供电方式
exports.FormatPowerSupply = (value) => {
	switch (value) {
		case 1:
		case "1": //自带电源(紫色)
			return "自带电源";
		case 2:
		case "2": //自带电源，太阳能补充电能(黄色)			
			return "自带电源，太阳能补充电能";
		case 3:
		case "3": //需市电(粉红色)
			return "需市电";
		case 4:
		case "4": //不带电源(绿色)
			return "不带电源";
	}
}

//资产分布-供电方式-对应颜色
exports.FormatProductPointColor = (value) => {
	switch (value) {
		case 1:
		case "1": //自带电源(紫色)
			return "cell-violet";
		case 2:
		case "2": //自带电源，太阳能补充电能(黄色)			
			return "cell-yellow";
		case 3:
		case "3": //需市电(粉红色)
			return "cell-pink";
		case 4:
		case "4": //不带电源(绿色)
			return "cell-green";
	}
}

//设备状态
exports.FormatDevStatus = (value) => {
	switch (value) {
		case 0:
		case "0":
			return "离线";
		case 1:
		case "1":
			return "在线";
		case 2:
		case "2":
			return "告警";
	}
}

//设备状态
exports.FormatDevStatusColor = (value) => {
	switch (value) {
		case 0:
		case "0":
			return "cell-grey";
		case 1:
		case "1":
			return "cell-green";
		case 2:
		case "2":
			return "cell-red";
	}
}

//终端命令类型
exports.FormatCMDType = (value) => {
	switch (value) {
		case '1':
			return "震动灵敏度";
		case '2':
			return "倾斜灵敏度";
		case '3':
			return "位移灵敏度";
		case '4':
			return "上报周期";
		case '5':
			return "激活状态";
		case '6':
			return "固件版本";
		case '7':
			return "安装校准";
		case '8':
			return "灯光控制";
		case '9':
			return "刷新在线状态";


		case '101':
			return "红灯亮度";
		case '102':
			return "黄灯亮度";
		case '103':
			return "黄灯闪烁周期";
		case '104':
			return "黄灯亮灯时间";
		case '105':
			return "红灯闪烁周期";
		case '106':
			return "红灯亮灯时间";
		case '107':
			return "尾迹追随保持时间";
		case '108':
			return "低温报警值";
		case '109':
			return "高温报警值";
		case '110':
			return "电压下限";
		case '111':
			return "电压恢复";
		case '112':
			return "满电电压";
		case '113':
			return "充电充足阈值";
		case '114':
			return "倾倒报警触发时间";
		case '115':
			return "GNSS最大等待时间";
		case '116':
			return "GNSS获取周期时间";
		case '117':
			return "同频网络ID";
		case '118':
			return "同频信道";
		default:
			return "";
	}
}


// WEBPACK FOOTER //
// ./src/common/js/filter.js